import { createFileRoute } from "@tanstack/react-router"
import ForgotPassword from "@/pages/account/forgot-password"

export const Route = createFileRoute("/$countryCode/account/forgot-password")({
  head: () => ({
    meta: [
      { title: "Forgot password | +Bake Cafe" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: ForgotPassword,
})
